import { IListItem } from '../../list-page/interfaces/interfaces';
import { sendGAEvent, sendGAEventAddToCart } from '../../../domain/marketing/gtm-provider';
import { ProductDepartmentEnum } from '../enums/product-department-enum';
import { getHiddenDataString } from '../../../domain/hidden-data-provider';
import { outbrainAddToCartEvent } from '../../../domain/marketing/outbrain-provider';

interface IProductBuyButtonProps {
    product: IListItem,
    listName?: string,
}

/**
 * Product buy button component.
 */
const ProductBuyButton = (props: IProductBuyButtonProps) => {

    const { product, listName } = props;

    const url = `/cart?productid=${product.skuid}`;
    let departmentID = Number(product.skuDepartmentID) || 0;
    if(departmentID === 0 && product.departmentID > 0){
        departmentID = product.departmentID;
    }
    const isFlex = departmentID === ProductDepartmentEnum.RentToOwnDynamic;

    const classes = 'w-btn-outline-black w-auto inline-block px-8 md:px-10';
    let buttonText = getHiddenDataString('sbs-button-text');

    if(product.skuNumber === 'SGRCKFAKE'){
        buttonText = 'Shop Now';
    }

    const hasDataCartOpen = !product.isProductOptions && (
        departmentID === ProductDepartmentEnum.Plugins ||
        departmentID === ProductDepartmentEnum.Bundles
    );

    const sendMarketingAddToCartEvents = () => {
        sendGAEventAddToCart(
            product.documentName,
            product.skuNumber,
            product.skuPrice,
            product.documentUrlPath,
            listName ? listName : 'List Page'
        );

        outbrainAddToCartEvent();
    };

    return (
        <div data-cart={ hasDataCartOpen ? 'open' : undefined }>
            {
                !product.isProductOptions && !isFlex && !product.isPreorder &&
                <a
                    href={ url }
                    className={ classes }
                    data-skunumber={ product.skuNumber }
                    onClick={ sendMarketingAddToCartEvents }>Add to Cart</a>
            }

            {
                !product.isProductOptions && !isFlex && product.isPreorder &&
                <a
                    href={ url }
                    className={ classes }
                    data-skunumber={ product.skuNumber }
                    onClick={ () => {
                        sendGAEvent(listName ? listName : 'List Page', 'Pre-Order');
                    }}>Pre-Order</a>
            }

            {
                isFlex &&
                <a
                    href={ product.documentUrlPath }
                    className={ classes }
                    data-skunumber={ product.skuNumber }
                    onClick={ () => {
                        sendGAEvent(listName ? listName : 'List Page', 'Get Started');
                    }}>Get Started</a>
            }

            {
                product.isProductOptions &&
                <a
                    href={ product.documentUrlPath}
                    className={ classes }
                    onClick={ () => {
                        sendGAEvent(listName ? listName : 'List Page', departmentID === ProductDepartmentEnum.Subscription ? buttonText : 'Shop Now');
                    }}>
                    { departmentID !== ProductDepartmentEnum.Subscription && <span>Shop Now</span> }
                    { departmentID === ProductDepartmentEnum.Subscription && <span>{ buttonText }{/* product.optionName === 'Annual' ? 'Start Now' : 'Start Free' */}</span> }
                </a>
            }
        </div>
    );
};

export default ProductBuyButton;
